
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/reviews",
      function () {
        return require("private-next-pages/phone/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/reviews"])
      });
    }
  